import { render, staticRenderFns } from "./mobileHomePage.vue?vue&type=template&id=71e137e9&scoped=true"
import script from "./mobileHomePage.vue?vue&type=script&lang=js"
export * from "./mobileHomePage.vue?vue&type=script&lang=js"
import style0 from "./mobileHomePage.vue?vue&type=style&index=0&id=71e137e9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e137e9",
  null
  
)

export default component.exports